import i18n from '@/i18n'
export function getHtml({status, type, physicalAddress, name, number, volume, areaName}, className) {
	let brocastHtml = ''
	if(status == 2){
		const {taskName, priority, broadcastType, broadcastVolume} = item
		let broadcastName = ''
		switch(broadcastType){
			case 1:
				broadcastName = i18n.t('realTimeBroadcast')
				break;
			case 2:
				broadcastName = i18n.t('timedBroadcast')
				break;
			case 3:
				broadcastName = i18n.t('emergencyPlan')
				break;
			case 4:
				broadcastName = i18n.t('fireLinkage')
				break;
			case 5:
				broadcastName = i18n.t('zdai')
				break;
			case 6:
				broadcastName = i18n.t('musicbroadcast')
				break;
		}
		brocastHtml = `
			<div class="el-form-item">
				<label class="el-form-item__label">${i18n.t('taskName')}:</label>
				<div class="el-form-item__content">${taskName || ''}</div>
			</div>
			<div class="el-form-item">
				<label class="el-form-item__label">${i18n.t('priority')}:</label>
				<div class="el-form-item__content">${priority || ''}</div>
			</div>
			<div class="el-form-item">
				<label class="el-form-item__label">${i18n.t('broadcastType')}:</label>
				<div class="el-form-item__content">${broadcastName || ''}</div>
			</div>
			<div class="el-form-item">
				<label class="el-form-item__label">${i18n.t('volume')}:</label>
				<div class="el-form-item__content">${broadcastVolume || ''}</div>
			</div>
		`
	}
	let text = ''
	switch(status){
		case -1:
			text = i18n.t('fault')
			break;
		case 0:
			text = i18n.t('offline')
			break;
		case 1:
			text = i18n.t('online')
			break;
		case 2:
			text = i18n.t('onTheAir')
			break;
		default:
			text = i18n.t('inIntercom')
			break;
	}
	let winHtml = `
	<div class="info-window">
		<div class="info-window-bg">
			<form class="el-form large-detail-form borderbox ${className}">
				<div class="el-form-item">
					<label class="el-form-item__label">${i18n.t('physicalAddress')}:</label>
					<div class="el-form-item__content">${physicalAddress || ''}</div>
				</div>
				<div class="el-form-item">
					<label class="el-form-item__label">${i18n.t('equipmentName')}:</label>
					<div class="el-form-item__content">${name || ''}</div>
				</div>
				<div class="el-form-item">
					<label class="el-form-item__label">${i18n.t('terminalNumber')}:</label>
					<div class="el-form-item__content">${number || ''}</div>
				</div>
				<div class="el-form-item">
					<label class="el-form-item__label">${i18n.t('area')}:</label>
					<div class="el-form-item__content">${areaName || ''}</div>
				</div>
				<div class="el-form-item">
					<label class="el-form-item__label">功率:</label>
					<div class="el-form-item__content">${volume || ''}</div>
				</div>
				<div class="el-form-item">
					<label class="el-form-item__label">状态:</label>
					<div class="el-form-item__content">
						<span class="${status == 1 ? 'green' : ''}">${text}</span>
					</div>
				</div>
				${brocastHtml}
			</form>
		</div>
		<div class="window-arrow"></div>
	</div>
	`
	return winHtml
}
export function getHtml2({deviceId, name, children, manufacturer, status}, className) {
	let winHtml = `
	<div class="info-window">
		<div class="info-window-bg">
			<form class="el-form large-detail-form borderbox">
				<div class="el-form-item">
					<label class="el-form-item__label">设备编号:</label>
					<div class="el-form-item__content">${deviceId}</div>
				</div>
				<div class="el-form-item">
					<label class="el-form-item__label">设备名称:</label>
					<div class="el-form-item__content">${name}</div>
				</div>
				<div class="el-form-item">
					<label class="el-form-item__label">通道数:</label>
					<div class="el-form-item__content">${children && children.length || 0}</div>
				</div>
				<div class="el-form-item">
					<label class="el-form-item__label">厂家:</label>
					<div class="el-form-item__content">${manufacturer}</div>
				</div>
				<div class="el-form-item">
					<label class="el-form-item__label">状态:</label>
					<div class="el-form-item__content">
						<span class="${status == 1 ? 'green' : ''}">${status == 1 ? '在线' : '离线'}</span>
					</div>
				</div>
			</form>
		</div>
		<div class="window-arrow"></div>
	</div>
	`
	return winHtml
}
export function getImgUrl(status, type, mtype){
	let imgUrl = ''
	switch(mtype){
		case 1:
			imgUrl = status == -1 ? `largedatascreen/${type}f.png` : `largedatascreen/${type}${status}.png`
			break
		case 2:
			imgUrl = `aimap/${status}.png`
			break
	}
	return imgUrl
}